// extracted by mini-css-extract-plugin
export var bgColor = "titlebar-module--bgColor--dWd4p";
export var headingText = "titlebar-module--headingText--SW0z5";